import { render, staticRenderFns } from "./studyVideo.vue?vue&type=template&id=37f3d4aa&scoped=true&"
import script from "./studyVideo.vue?vue&type=script&lang=js&"
export * from "./studyVideo.vue?vue&type=script&lang=js&"
import style0 from "./studyVideo.vue?vue&type=style&index=0&id=37f3d4aa&prod&lang=less&scoped=true&"
import style1 from "./studyVideo.vue?vue&type=style&index=1&id=37f3d4aa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f3d4aa",
  null
  
)

export default component.exports